import { render } from "./ProfilePermissionsConfiguration.vue?vue&type=template&id=c6d0b854&scoped=true&ts=true"
import script from "./ProfilePermissionsConfiguration.vue?vue&type=script&lang=ts"
export * from "./ProfilePermissionsConfiguration.vue?vue&type=script&lang=ts"

import "./ProfilePermissionsConfiguration.vue?vue&type=style&index=0&id=c6d0b854&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6d0b854"]])

export default __exports__